export const text = {
  loading: 'Estamos cargando tus'
};
